import React from 'react'
import { ExecuteOperationOnPipe } from '@morningtrain/react-resources'
import { NestedAsyncPipeline } from '@morningtrain/react-pipelines'
import ScheduleSlotRefreshPipes from 'support/actions/shifts/ScheduleSlotRefreshPipes'

export default function ShiftExchangeRefreshPipes ({ slotId }) {
  return (
    <>
      <NestedAsyncPipeline>
        <ScheduleSlotRefreshPipes slotId={slotId} />
        <ExecuteOperationOnPipe resourceName='shifts.exchange' operationName='requests' />
      </NestedAsyncPipeline>
    </>
  )
}
